import React from "react";
import styled from "styled-components";
import { Typography } from '@blueprint/ui';

const PlatformTermsOfUse = (): JSX.Element => {
    return (
        <>
            <StyledH5 variant="h5">BY SELECTING “I AGREE”:</StyledH5>
            <dl className="h5 ml-r1">
                <dd>
                <b>• THE INDIVIDUAL MAKING THE SELECTION CONFIRMS TO THE PLATFORM OPERATOR THAT IT AGREES TO COMPLY
                    WITH THESE TERMS AND THAT IT HAS THE NECESSARY CAPACITY AND AUTHORITY TO AGREE TO THESE TERMS ON
                    BEHALF OF THE USER;</b>
                </dd>
                <dd>
                • THE INDIVIDUAL MAKING THE SELECTION CONFIRMS ITS AGREEMENT TO THE PLATFORM OPERATOR’S DATA PRIVACY
                POLICY (INCLUDING THE PLATFORM’S COOKIE POLICY) WHICH CAN BE FOUND AT:
                <a href="https://www.business.hsbc.com.sg/en-sg/regulations/privacy-and-security#DPP" target="_blank" rel="noopener noreferrer">
                https://www.business.hsbc.com.sg/en-sg/regulations/privacy-and-security#DPP</a><b>; AND</b>
                </dd>
                <dd>
                <b>• A LEGALLY BINDING CONTRACT IS CREATED BETWEEN THE PLATFORM OPERATOR AND THE USER </b>(each a
                <b> party </b>and together the<b> parties</b>, unless the context otherwise provides).
                </dd>
            </dl>
            <StyledH5 variant="h5">
                1 PLATFORM SERVICE
            </StyledH5>
            <dl className="ml-r1">
                1.1	In relation to a Designated Project, the User may access and use the Platform solely to:
                <dd className="ml-r1">
                    (a)	submit, view and receive Platform Materials; and
                </dd>
                <dd className="ml-r1">
                    (b)	communicate with other associated Users connected to the same Designated Project,
                </dd>
                <dd className="ml-r1">
                    to support payment workflows for such Designated Project (the “<b>Platform Service</b>”).
                </dd>
            </dl>
            <dl className="ml-r1">
                1.2	It is the User’s responsibility to ensure that:
                <dd className="ml-r1">
                    (a)	all information in the Platform Materials it submits on the Platform is accurate, complete and
                    correct; and
                </dd>
                <dd className="ml-r1">
                    (b)	it checks the accuracy, completeness and correctness of any other User’s Platform Materials
                    before relying or acting on them.
                </dd>
            </dl>
            <dl className="ml-r1">
                1.3	The Platform Operator is not obliged to do anything to verify the accuracy, completeness and
                correctness of any Platform Materials submitted on the Platform and shall not be responsible for any
                Loss suffered or incurred by any User in this regard.
            </dl>
            <dl className="ml-r1">
                1.4	The Platform Operator shall be entitled, without the need for the consent or approval of any User
                to correct or reverse an erroneous transaction involving the Platform.
            </dl>
            <dl className="ml-r1">
                1.5	These Terms govern the Platform Operator’s provision of access to the Platform and the Platform
                Service to the Users.
            </dl>
            <StyledH5 variant="h5">
                2 USER OBLIGATIONS
            </StyledH5>
            <dl className="ml-r1">
                2.1	The User shall (at its own cost):
                <dd className="ml-r1">
                    (a)	select, provide, maintain and support the equipment, software, networks, connections, computer
                    systems, technology and infrastructure necessary for the User to access and use the Platform;
                </dd>
                <dd className="ml-r1">
                    (b)	regularly review its internal security measures and controls to ensure that they are up-to-date,
                    effective and aligned with regulatory and industry best practice guidance. The internal security
                    measures and controls should include (without limitation) malware protection, network restrictions,
                    hardware and software patching or evergreening, physical and remote access restrictions, computer
                    device settings, monitoring of improper usage, and guidance on acceptable web browsers and email
                    usage, including on how to avoid getting infected by malware;
                </dd>
                <dd className="ml-r1">
                    (c)	in respect of its own computing environment, procure all permissions, licences, waivers,
                    consents, registrations, and approvals necessary to receive and use the Platform Service;
                </dd>
                <dd className="ml-r1">
                    (d)	not circumvent or attempt to circumvent any of the security measures or operating systems used
                    by the Platform Operator in connection with the Platform; and
                </dd>
                <dd className="ml-r1">
                    (e)	comply with these Terms, all Applicable Laws and all other reasonable requirements and
                    instructions of the Platform Operator relating to the access of and use of the Platform and the
                    Platform Service.
                </dd>
            </dl>
            <dl className="ml-r1">
                2.2	The User shall:
                <dd className="ml-r1">
                    (a)	keep all login details and credentials used to access the Platform secret and implement security
                    measures to prevent access to the Platform by any unauthorised person;
                </dd>
                <dd className="ml-r1">
                    (b)	If it knows or suspects that any of its login details and credentials used to access the
                    Platform have been lost, stolen or compromised, to immediately:
                    <dl>
                    <dd className="ml-r1">
                        (i) carry out a review;
                    </dd>
                    <dd className="ml-r1">
                        (ii) notify the Platform Operator; and
                    </dd>
                    <dd className="ml-r1">
                        (iii) ensure that the login details and credentials are changed.
                    </dd>
                    </dl>
                </dd>
                <dd className="ml-r1">
                    (c)	report to the Platform Operator as soon as possible:
                    <dl>
                    <dd className="ml-r1">
                        (i)	if it becomes aware of any actual or attempted unauthorised access to the Platform or any
                        actual or suspected cyber-incident in relation to the Platform; and
                    </dd>
                    <dd className="ml-r1">
                        (ii) any activities (including financing requests or approvals) which are, or that the User
                        believes to be, use or an attempted use of the Platform Service in a fraudulent manner
                        (including making any suspected fraudulent misrepresentations).
                    </dd>
                    </dl>
                </dd>
            </dl>
            <StyledH5 variant="h5">
                3 INTELLECTUAL PROPERTY RIGHTS
            </StyledH5>
            <dl className="ml-r1">
                3.1	The User hereby grants the Platform Operator an irrevocable, royalty-free and non-exclusive licence
                in perpetuity to use all User Information for the purpose of providing, improving and enhancing the
                Platform Service.
            </dl>
            <dl className="ml-r1">
                3.2	The User shall retain, all Intellectual Property Rights in its User Information.
            </dl>
            <dl className="ml-r1">
                3.3	The Platform Operator will retain ownership of all Intellectual Property Rights relating to:
                <dd className="ml-r1">
                    (a)	the Platform Service;
                </dd>
                <dd className="ml-r1">
                    (b)	the Platform;
                </dd>
                <dd className="ml-r1">
                    (c)	other materials and/or information made available by the Platform Operator to provide the
                    Platform Service;
                </dd>
                <dd className="ml-r1">
                    (d)	any data and/or information made available by the Platform Operator in connection with these
                    Terms; and
                </dd>
                <dd className="ml-r1">
                    (e)	data, analyses or other information that have been derived from and/or generated by any use
                    (including by the User) of the Platform and the Platform Service;
                </dd>
                <dd className="ml-r1">
                    but, in each case, excluding the User Materials (the “<b>Platform Intellectual Property</b>”).
                    Except as licensed in accordance with clause 3.5, the User shall not acquire any Intellectual
                    Property Rights in and to the Platform Intellectual Property and clause 3.6 shall apply if and/or
                    to the extent that they might otherwise do so.
                </dd>
            </dl>
            <dl className="ml-r1">
                3.4	The Platform Operator grants the User a revocable, non-exclusive, non-transferable, non-sub
                licensable licence during the term that the Platform Services are provided, solely for the purposes of
                accessing and using the Platform and receiving the Platform Service in the User’s normal course of
                business and in accordance with these Terms (the “<b>User Licence</b>”).
            </dl>
            <dl className="ml-r1">
                3.5	The User shall not:
                <dd className="ml-r1">
                    (a)	use the Platform or any available metadata derived from the Platform in any manner outside of
                    the scope of receiving the Platform Service;
                </dd>
                <dd className="ml-r1">
                    (b)	alter, copy, modify, reverse engineer, disassemble, decompile, decode or adapt any part of the
                    Platform;
                </dd>
                <dd className="ml-r1">
                    (c)	subject any part of the Platform to error corrections;
                </dd>
                <dd className="ml-r1">
                    (d)	derive or gain access, or attempt to derive or gain access to the source code of the Platform; or
                </dd>
                <dd className="ml-r1">
                    (e)	use the Platform or Platform Service in any manner that infringes or misappropriates any
                    intellectual property right or other right of any person, or that violates any Applicable Law.
                </dd>
            </dl>
            <dl className="ml-r1">
                3.6	If (at any time) through the provision of the Platform Service and/or use of the Platform, or by
                operation of Applicable Law, or otherwise, the User comes to own Intellectual Property Rights in the
                Platform Intellectual Property, the User shall (promptly on request from the Platform Operator and
                without delay) assign (or procure the assignment of) such Intellectual Property Rights to the Platform
                Operator and to the extent permitted by Applicable Law, waive (or procure the waiver of) all moral
                rights (and analogous rights) worldwide in connection with such Platform Intellectual Property.
            </dl>
            <StyledH5 variant="h5">
                4 CONFIDENTIALITY
            </StyledH5>
            <dl className="ml-r1">
                4.1	Subject to clauses 5 and 6 of these Terms, the parties agree that any Confidential Information and
                User Information shall be kept confidential.
            </dl>
            <dl className="ml-r1">
                4.2	The parties consent to the monitoring or recording of communications (including electronic mail,
                telephone calls and website usage) where required or allowed by Applicable Law or to ensure compliance
                with the parties’ respective policies and procedures. The parties further agree that either party may
                produce such records as evidence in any proceedings brought in connection with these Terms.
            </dl>
            <dl className="ml-r1">
                4.3	The restrictions on the disclosure of Confidential Information and User Information by either party
                shall not apply to information that:
                <dd className="ml-r1">
                    (a)	is in or enters into the public domain other than in breach of these Terms;
                </dd>
                <dd className="ml-r1">
                    (b)	is lawfully obtained by the recipient party from a third party or is already known by the
                    recipient party, in each case without notice or duty to maintain it as confidential; or
                </dd>
                <dd className="ml-r1">
                    (c)	was independently developed by the recipient party without reference to the disclosing party’s
                    Confidential Information and (in the case of the User) User Information.
                </dd>
            </dl>
            <StyledH5 variant="h5">
                5 COLLECTION AND USE OF USER INFORMATION
            </StyledH5>
            <dl className="ml-r1">
                5.1	The Platform Operator may collect, use and share the User Information, which may be requested from
                a person acting on the User’s behalf. User Information may also be collected by or on behalf of members
                of the Group from other sources, and generated or combined with other information available to members
                of the Group.
            </dl>
            <dl className="ml-r1">
                5.2	User Information will be processed, transferred and disclosed by the Platform Operator and/or
                members of the Group in connection with:
                <dd className="ml-r1">
                    (a)	the provision of the Platform Service and as necessary for the Platform Operator to approve,
                    manage, administer or effect any transaction or process with respect to the Platform Service;
                </dd>
                <dd className="ml-r1">
                    (b)	meeting Compliance Obligations;
                </dd>
                <dd className="ml-r1">
                    (c)	conducting Compliance Activity;
                </dd>
                <dd className="ml-r1">
                    (d)	to enforce or defend the Platform Operator’s or a member of the Group’s rights;
                </dd>
                <dd className="ml-r1">
                    (e)	for internal operational requirements of the Platform Operator or the Group (including, without
                    limitation, credit and risk management, system or product development and planning, insurance,
                    audit and administrative purposes); and
                </dd>
                <dd className="ml-r1">
                    (f)	the maintenance of the Platform Operator’s relationship with the User,
                </dd>
                <dd className="ml-r1">
                    (collectively, the “<b>Purposes</b>”).
                </dd>
            </dl>
            <dl className="ml-r1">
                5.3	By using and accessing the Platform and receiving the Platform Service, the User agrees that the
                Platform Operator may also, as necessary and appropriate for the Purposes, transfer and disclose any
                User Information to the following recipients globally (who may also process, transfer and disclose such
                User Information for the Purposes):
                <dl>
                <dd className="ml-r1">
                    (a)	any member of the Group;
                </dd>
                <dd className="ml-r1">
                    (b)	any sub-contractors, agents, service providers, or associates of the Group (including their
                    employees, directors and officers);
                </dd>
                <dd className="ml-r1">
                    (c)	in response to any requests from any Authority;
                </dd>
                <dd className="ml-r1">
                    (d)	persons acting on behalf of the User, Infrastructure Providers, payment recipients,
                    beneficiaries, account nominees, agent banks, market counterparties, upstream withholding agents,
                    swap or trade repositories, stock exchanges, and companies in which the User has an interest in
                    securities (where such securities are held by the Platform Operator for the User);
                </dd>
                <dd className="ml-r1">
                    (e)	any party to a transaction acquiring interest in or assuming risk in or in connection with the
                    Platform Service;
                </dd>
                <dd className="ml-r1">
                    (f)	other financial institutions, credit reference agencies or credit bureaus, for the purposes of
                    obtaining or providing credit references; and
                </dd>
                <dd className="ml-r1">
                    (g)	in response to any potential payer’s request, the Platform Operator’s confirmation limited to
                    the User’s bank account information to that potential payer, its payment service provider and
                    persons acting on their behalf,
                </dd>
                <dd className="ml-r1">
                    wherever located, including in jurisdictions which do not have data protection laws that provide the
                    same level of protection as the jurisdiction in which the Platform Service is supplied.
                </dd>
                </dl>
            </dl>
            <dl className="ml-r1">
                5.4	The User acknowledges and agrees that User Information relating to payment workflows and use of the
                Platform Service may be recorded on distributed ledger technology. Due to the nature of such technology,
                such User Information cannot be deleted, removed, reversed or altered and will remain permanently on the
                Platform until the Platform is decommissioned by the Platform Operator.
            </dl>
            <dl className="ml-r1">
                5.5	The User confirms, warrants, and has responsibility to ensure that every person whose information
                they have provided to the Platform Operator and/or a member of the Group has (or will at the relevant
                time have) been notified of and agree to the processing, disclosure and transfer of their User
                Information as set out in these Terms. The User shall advise such persons that they may have rights of
                access to, and correction of, their Personal Data.
            </dl>
            <dl className="ml-r1">
                5.6	The User consents to the Platform Operator disclosing and transferring its User Information and
                Platform Materials to:
                <dd className="ml-r1">
                    (a)	other associated Users connected to the same Designated Project; and
                </dd>
                <dd className="ml-r1">
                    (b)	any Authority in connection with a Designated Project.
                </dd>
            </dl>
            <dl className="ml-r1">
                5.7	In relation to User Information, these Terms are supplemented by the Platform Operator’s Data
                Privacy Notice which can be found at: <a href="https://www.business.hsbc.com.sg/en-sg/regulations/privacy-and-security#DPP" target="_blank" rel="noopener noreferrer">
                https://www.business.hsbc.com.sg/en-sg/regulations/privacy-and-security#DPP</a>. The User agrees and
                acknowledges that the Platform Operator may use the User Information in accordance with these Terms and
                where applicable, the Data Privacy Notice.
            </dl>
            <StyledH5 variant="h5">
                6 COMPLIANCE WITH LAWS
            </StyledH5>
            <dl className="ml-r1">
                6.1	Each party shall, in connection with their performance of these Terms and use of the Platform
                Service, during the Term:
                <dd className="ml-r1">
                    (a)	comply with all Applicable Laws relating to:
                </dd>
                    <dl>
                    <dd className="ml-r1">
                        (i)	bribery, fraud, kickback, or other similar anti-corruption law or regulation; and
                    </dd>
                    <dd className="ml-r1">
                        (ii) money laundering, terrorist financing, or transactions involving the proceeds of illegal
                        activities, or any applicable legislation or regulatory requirements in any jurisdiction; and
                    </dd>
                    </dl>
                <dd className="ml-r1">
                    (b)	implement and maintain adequate procedures designed to promote and achieve compliance with such
                    Applicable Laws (whether specific to the Platform or not).
                </dd>
            </dl>
            <dl className="ml-r1">
                6.2	The User hereby acknowledges and agrees that it is solely responsible for assessing the suitability
                and the lawfulness of its interactions with other Users.
            </dl>
            <StyledH5 variant="h5">
                7 LIMITATION OF LIABILITY
            </StyledH5>
            <dl className="ml-r1">
                7.1	The Platform Operator excludes all liability for any Loss arising out of the following:
                <dd className="ml-r1">
                    (a)	Downtime; and/or
                </dd>
                <dd className="ml-r1">
                    (b)	Cyber Risks.
                </dd>
            </dl>
            <dl className="ml-r1">
                7.2	The User indemnifies and holds the Platform Operator harmless in full against any direct Loss
                arising from or in connection with the Platform Operator providing the Platform Service to the User,
                except to the extent that such Loss has been caused by the negligence or wilful misconduct of the
                Platform Operator.
            </dl>
            <dl className="ml-r1">
                7.3	Neither party shall be liable to the other (or any person claiming under or through the other)
                whether in contract, in tort (including negligence), under statute or otherwise under or in connection
                with these Terms for any:
                <dd className="ml-r1">
                    (a)	incidental or indirect Loss including, without limitation, fines, penalties or punitive damages; or
                </dd>
                <dd className="ml-r1">
                    (b)	any direct or indirect loss of (i) profit (actual or anticipated); (ii) goodwill; or (iii)
                    business opportunity,
                </dd>
                <dd className="ml-r1">
                    whether or not foreseeable, even if one party advised the other of the possibility of such loss or
                    damage.
                </dd>
            </dl>
            <StyledH5 variant="h5">
                8 TERMINATION
            </StyledH5>
            <dl className="ml-r1">
                8.1	Either party may terminate these Terms at any time on thirty (30) days’ written notice to the other
                party.
            </dl>
            <dl className="ml-r1">
                8.2	The Platform Operator may suspend access to the Platform Services and/or terminate these Terms
                immediately if the User commits a breach of these Terms or which, with respect to the Platform Operator,
                includes any activity by the User which puts the Platform Operator or any member of the Group at
                material risk of violating its Compliance Obligations.
            </dl>
            <dl className="ml-r1">
                8.3	On termination of these Terms, the following clauses will remain in force: 3 to 5, 7, 8, 12, and 13.
                Termination of this Services Schedule will not affect any rights, remedies, obligations or liabilities
                of the parties that have accrued up to the date of termination. Termination shall not affect any accrued
                rights or liabilities of either party with respect to clauses 1.2 to 1.4, 2 to 12 inclusive).
            </dl>
            <StyledH5 variant="h5">
                9 NOTICES
            </StyledH5>
            <dl className="ml-r1">
                9.1	Notices in writing from:
                <dd className="ml-r1">
                    (a)	the Platform Operator shall be effective if delivered to an address specified by the User as
                    part of the registration process for the Platform Service; and
                </dd>
                <dd className="ml-r1">
                    (b)	the User shall be effective if delivered to the Platform Operator’s address specified below.
                </dd>
                <dd className="ml-r1">
                    <a href="mailto:enterprise.dlt.payment.service@hsbc.com.sg">enterprise.dlt.payment.service@hsbc.com.sg</a>
                </dd>
                <dd className="ml-r1">
                    In each case a party may, from time to time, specify another address in writing to the other party
                    as effective for delivery of notices pursuant to these Terms, including an address for notices to be
                    sent electronically.
                </dd>
            </dl>
            <StyledH5 variant="h5">
                10 FORCE MAJEURE
            </StyledH5>
            <dl className="ml-r1">
                10.1 The parties shall not be liable for any Loss caused by a Force Majeure Event. If either party or
                member of the Group is prevented or delayed in the performance of any of its obligations under these
                Terms by a Force Majeure Event, such party shall as soon as reasonably practicable notify the relevant
                party of the existence of the Force Majeure Event. The duty of the Platform Operator or any member of
                the Group, and the User to perform any obligation under these Terms shall be suspended to the extent
                that and for as long as such party is prevented or restricted from doing so by a Force Majeure Event.
            </dl>
            <StyledH5 variant="h5">
                11 VARIATIONS
            </StyledH5>
            <dl className="ml-r1">
                11.1 The Platform Operator may amend these Terms by written notice to the User. Such amendment will
                become effective no less than sixty (60) days after delivery of such notice.
            </dl>
            <dl className="ml-r1">
                11.2 Notwithstanding clause 11.1, the Platform Operator may, by written notice to the User, make
                amendments to these Terms at any time in order to comply with any Applicable Laws, which will become
                effective in accordance with the terms of such notice. The Platform Operator will use reasonable efforts
                to give the User as much advance notice as possible in such circumstances.
            </dl>
            <dl className="ml-r1">
                11.3 Without prejudice to any other of the Platform Operator’s rights in these Terms, the Platform
                Operator has sole discretion and control over and may modify at any time (at its discretion and with or
                without notice to the User) the functionality, performance, configuration, appearance and content of
                the Platform.
            </dl>
            <StyledH5 variant="h5">
                12 GENERAL
            </StyledH5>
            <dl className="ml-r1">
                12.1 The provision of the Platform Service and the Platform by the Platform Operator may be affected by
                Compliance Activity and any impact on the performance of the Platform Operator’s obligations due to
                Compliance Activity or any actions taken by the Platform Operator as a result thereof shall not
                constitute a breach of these Terms.
            </dl>
            <dl className="ml-r1">
                12.2 The Platform Service may be subjected to the following risks:
                <dd className="ml-r1">
                    (a)	the Platform Service relies on the proper performance and integrity of distributed ledger
                    technology;
                </dd>
                <dd className="ml-r1">
                    (b)	the use of distributed ledger technology is in nascent stages of maturity, is constantly
                    evolving and is subject to further regulatory development;
                </dd>
                <dd className="ml-r1">
                    (c)	any software upgrades or other changes to the Platform Service and the Platform may fail to
                    function as originally intended, or may introduce security risks, or otherwise adversely affect the
                    Platform’s speed, security or usability;
                </dd>
                <dd className="ml-r1">
                    (d)	the Platform Service and the Platform (including its nodes) may be a target of Cyber Risks. Such
                    incidents may result in the inaccurate execution and recording of distributed ledger technology
                    transactions; and
                </dd>
                <dd className="ml-r1">
                    (e)	the Platform Operator may be prevented from accessing and/or using the Platform, which may in
                    turn materially and adversely affect its ability to perform its obligations under these Terms.
                </dd>
            </dl>
            <dl className="ml-r1">
                12.3 The Platform Operator may issue any public relations or advertising materials or make any public
                announcement regarding the User’s use of the Platform (including by using the User’s trading name,
                trademarks, and other representations related to the User’s brand) without the User’s prior consent.
            </dl>
            <dl className="ml-r1">
                12.4 In the event that any party fails or delays to exercise a right under these Terms, that party may
                still exercise that right later. Any waiver of any right under these Terms shall be in writing and
                shall be limited to the specific circumstance stated.
            </dl>
            <dl className="ml-r1">
                12.5 Each provision of these Terms is severable and if any provision is or becomes invalid, illegal or
                unenforceable, then only that provision is severed. All other provisions shall continue to have effect.
            </dl>
            <dl className="ml-r1">
                12.6 No User may assign its rights or transfer its obligations under these Terms without the written
                consent of the Platform Operator, such consent not to be unreasonably withheld or delayed. However the
                Platform Operator may, without the User’s consent, assign the Platform Operator’s rights and/or
                transfer its obligations to:
                <dd className="ml-r1">
                    (a)	any member of the Group; or
                </dd>
                <dd className="ml-r1">
                    (b)	to the Platform Operator’s successor following a merger, consolidation or disposal of all or
                    substantially all of the Platform Operator’s shares, capital, assets or the business to which these
                    Terms relate,
                </dd>
                <dd className="ml-r1">
                    provided that such assignment does not adversely affect the provision of the Platform Services to
                    the Users.
                </dd>
            </dl>
            <dl className="ml-r1">
                12.7 These Terms constitutes the entire agreement and understanding between the parties in respect of
                the access and use of the Platform Service and supersedes any previous agreement between the parties
                relating to such matter.
            </dl>
            <dl className="ml-r1">
                12.8 To the fullest extent permitted by Applicable Law, anyone not a party to these Terms (other than
                members of the Group) has no right to enforce any of the Terms, regardless of whether such right is
                provided under Applicable Law.
            </dl>
            <dl className="ml-r1">
                12.9 These Terms shall be electronically signed by the User by clicking “I Agree” or similar. In using
                this electronic method of providing agreement to the provision of the Platform Service, such use shall,
                subject to any additional terms and conditions provided to the User prior to such use (as the case may
                be), constitute full and binding consent by the User as if the User had provided such consent executed
                in writing.
            </dl>
            <dl className="ml-r1">
                12.10 These Terms and any non-contractual obligations arising out of or in connection with them shall
                be governed by and construed in accordance with the laws of the Republic of Singapore.
            </dl>
            <dl className="ml-r1">
                12.11 The parties submit to the non- exclusive jurisdiction of the courts of the Republic of Singapore.
            </dl>
            <StyledH5 variant="h5">
                13 DEFINITIONS
            </StyledH5>
            <dl className="ml-r1">
                “<b>Applicable Law</b>” means any applicable local or foreign statute, law, regulation, ordinance, rule,
                judgment, decree, voluntary code, directive, sanctions regime, court order, agreement between any member
                of the Group and an Authority, or agreement or treaty between Authorities and applicable to the Platform
                Operator or a member of the Group, as may be amended or varied from time to time.
            </dl>
            <dl className="ml-r1">
                “<b>Authority</b>” means any judicial, administrative or regulatory body, any government, or public or
                government agency, instrumentality or authority, any tax authority, securities or futures exchange,
                court, central bank or law enforcement body, or any agents thereof, having jurisdiction over the
                relevant party or a member of its group.
            </dl>
            <dl className="ml-r1">
                “<b>Compliance Activity</b>” means any activity performed by the Platform Operator or any other member of
                the Group considered appropriate, acting reasonably, to meet Compliance Obligations relating to or in
                connection with the detection, investigation and prevention of Financial Crime, international and
                national guidance, relevant Group procedures and/or the direction of any public, regulatory or industry
                body relevant to any member of the Group.
            </dl>
            <dl className="ml-r1">
                “<b>Compliance Obligations</b>” means obligations of any member of the Group to comply with: (a)
                Applicable Laws, or international guidance and the Platform Operator’s mandatory policies or procedures;
                (b) any demand from any Authority or reporting, regulatory trade reporting, disclosure or other
                obligations under Applicable Laws; or (c) any Applicable Laws requiring the Platform Operator to verify
                the identity of its Users.
            </dl>
            <dl className="ml-r1">
                “<b>Confidential Information</b>” means any information, about or relating to either party or members
                of its group, received or accessed by the other party in the course of the relationship established by
                them pursuant to these Terms, including without limitation, the business operations, Personal Data or
                customers of the disclosing party or members of its group and the provisions of these Terms.
            </dl>
            <dl className="ml-r1">
                “<b>Cyber Risks</b>” means malicious attacks seeking to identify and exploit weakness in software and
                susceptibility to cyberattacks or security breaches.
            </dl>
            <dl className="ml-r1">
                “<b>Designated Project</b>” means a development project that is designated by the Project Owner to the
                Platform Operator as a project whereby the Platform Service may be used by the Project Owner and other
                Users connected to such project.
            </dl>
            <dl className="ml-r1">
                “<b>Downtime</b>” means all or part of the Platform Service being unavailable due to security issues,
                system maintenance/ downtime, response failures, response time delay or any other event of a similar
                nature.
            </dl>
            <dl className="ml-r1">
                “<b>Financial Crime</b>” means money laundering, terrorist financing, bribery, corruption, tax evasion,
                fraud, evasion of economic or trade sanctions, and/or violations, or attempts to circumvent or violate
                any laws or regulations relating to these matters.
            </dl>
            <dl className="ml-r1">
                “<b>Force Majeure Event</b>” means any event beyond either party’s reasonable control affecting that
                party’s ability to comply with these Terms including, but not limited to:
                <dd className="ml-r1">
                    (a)	any natural event such as flood, storm or earthquake;
                </dd>
                <dd className="ml-r1">
                    (b)	war, civil disturbance or act of terrorism;
                </dd>
                <dd className="ml-r1">
                    (c)	industrial action;
                </dd>
                <dd className="ml-r1">
                    (d)	Act of God;
                </dd>
                <dd className="ml-r1">
                    (e)	action of a government or governmental agency;
                </dd>
                <dd className="ml-r1">
                    (f)	change in Applicable Laws (or change in the interpretation of Applicable Laws);
                </dd>
                <dd className="ml-r1">
                    (g)	power or equipment failure or interruption;
                </dd>
                <dd className="ml-r1">
                    (h)	interruption, failure or delay in any communications, systems, networks, hardware, software or
                    utility service;
                </dd>
                <dd className="ml-r1">
                    (i)	non-performance by suppliers, subcontractors or third parties,
                </dd>
            </dl>
            <dl className="ml-r1">
                <b>PROVIDED ALWAYS that</b> any non-compliance with these Terms resulting from such an event could not
                be avoided by the exercise of commercially reasonable skill and care by the affected party which, in
                the case of the Platform Operator, may include invocation of a business continuity plan.
            </dl>
            <dl className="ml-r1">
                “<b>Group</b>” means HSBC Holdings plc, its subsidiaries, related bodies corporate, associated entities
                and undertakings and any of their branch.
            </dl>
            <dl className="ml-r1">
                “<b>Infrastructure Provider</b>” means any third party, excluding sub-contractors or agents of the
                Platform Operator, providing shared market infrastructure necessary for a party to perform its
                obligations under these Terms including any communications, clearing, settlement or payment system, or
                intermediary or correspondent bank.
            </dl>
            <dl className="ml-r1">
                “<b>Intellectual Property Rights</b>” means all patents, rights to inventions, utility models, copyright
                and related rights, trademarks, service marks, trade, business and domain names, rights in trade dress
                or get-up, rights in goodwill or to sue for passing off, unfair competition rights, rights in designs,
                rights in computer software, database rights, topography rights, moral rights, rights in confidential
                information (including know-how and trade secrets) and any other intellectual property rights, in each
                case whether registered or unregistered and including all applications for and renewals or extensions of
                such rights, and all similar or equivalent rights or forms of protection in any part of the world.
            </dl>
            <dl className="ml-r1">
                “<b>Loss</b>” means any loss, damages, liability, costs, claims, demands and expenses of any kind
                whether or not foreseeable.
            </dl>
            <dl className="ml-r1">
                “<b>Personal Data</b>” means any data relating to an individual and allowing the identification of that
                individual, and such other data which is protected by all data protection, privacy, and other laws to
                the same or similar purpose in all relevant jurisdictions applicable to a party.
            </dl>
            <dl className="ml-r1">
                “<b>Platform</b>” means the distributed ledger technology-based platform that the Platform Operator
                provides for access and use by the Users for supporting the payment workflows for the Project Owner’s
                Designated Projects.
            </dl>
            <dl className="ml-r1">
                “<b>Platform Materials</b>” means all data, information and other materials (including, but not limited
                to invoices, purchase orders and payment orders, payment requests, payment instructions and credits
                received into the Project Owner’s designated project account) uploaded or submitted to the Platform by
                or on behalf of the Users.
            </dl>
            <dl className="ml-r1">
                “<b>Platform Operator</b>” means The Hong Kong and Shanghai Banking Corporation Limited, Singapore
                Branch, a banking institution incorporated under the laws of Hong Kong and with an office in Singapore.
            </dl>
            <dl className="ml-r1">
                “<b>Platform Service</b>” is defined in Clause 1.1.
            </dl>
            <dl className="ml-r1">
                “<b>Project Owner</b>” means the owner, operator or developer of a development project that wishes to
                use the Platform Service for concluding transactions for its Designated Projects.
            </dl>
            <dl className="ml-r1">
                “<b>Purposes</b>” is defined in Clause 5.2.
            </dl>
            <dl className="ml-r1">
                “<b>User Information</b>” means the Confidential Information, Platform Materials and Personal Data in
                respect of a User.
            </dl>
            <dl className="ml-r1">
                “<b>User</b>” means any entity that the Platform Operator permits to access and use the Platform Service
                and the Platform, and includes the Project Owner.
            </dl>
        </>
    );
};

const StyledH5 = styled(Typography)`
    font-weight: bold;
`;

export default PlatformTermsOfUse;
